module.exports = "/c9752e51ec0adb99f9aeafd2c2676cd0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/brands/ghd.png
 ** module id = 2206
 ** module chunks = 0
 **/